// Facebook Conversions API Google Tag Manager Event handling
import { getUniqueEventId } from './getEventId';
import { gtagEnvelope } from './gtagEnvelope';
import { hashEncodeUserDataField } from './hashEncodeUserDataField';
export const facebookCAPIGTMEvent = async (payloadValues: {
  contentId: string;
  firstName?: string | null;
  lastName?: string | null;
  email?: string | null;
  phone?: string | null;
}) => {
  const { contentId, firstName, lastName, email, phone } = payloadValues;
  try {
    const [first_name, last_name, email_address, phone_number] = await Promise.all([
      hashEncodeUserDataField(firstName, 'name'),
      hashEncodeUserDataField(lastName, 'name'),
      hashEncodeUserDataField(email, 'email'),
      hashEncodeUserDataField(phone, 'phone'),
    ]);
    const event_id = getUniqueEventId();
    const pixelData = {
      content_ids: [contentId],
      event_id,
      value: '0',
      ...(typeof first_name === 'string' ? { first_name } : {}),
      ...(typeof last_name === 'string' ? { last_name } : {}),
      ...(typeof email_address === 'string' ? { email_address } : {}),
      ...(typeof phone_number === 'string' ? { phone_number } : {}),
    };
    gtagEnvelope('event', 'start_trial', pixelData);
    if (window.dataLayer_standard) {
      const standardPixelData = {
        event: 'start_trial',
        event_id,
        ...pixelData,
      };
      window.dataLayer_standard.push(standardPixelData);
    }
  } catch (err: any) {
    console.warn('fb_CAPI event issue');
    console.warn(err.message);
  }
};
